import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  jobOrderDetail: {},
  isJobOrderDetailLoading: false,
  isJobOrderDetailUpdated: false,
  isRosterActionProcessing: false,
  isCancelProcessing: false,
  isCancelSeriesProcessing: false,
  isCancelledPlacementLoading: false,
  cancelledPlacement: {},
};

export const jobOrderDetailSlice = createSlice({
  name: 'jobOrderDetailV2Slice',
  initialState,
  reducers: {
    /* eslint-disable no-param-reassign */
    getJobOrderDetailV2: (state) => {
      state.isJobOrderDetailLoading = true;
    },
    getJobOrderDetailProcessedV2: (state, action) => {
      state.isJobOrderDetailLoading = false;
      state.jobOrderDetail = action.payload.data?.jobOrder;
      state.isJobOrderDetailUpdated = false;
    },
    getJobOrderDetailErrorV2: (state) => {
      state.isJobOrderDetailLoading = false;
      state.jobOrderDetail = {};
      state.isJobOrderDetailUpdated = false;
    },
    setJobOrderDetailV2: (state, action) => {
      state.jobOrderDetail = action.payload;
    },

    getCancelledPlacementDetail: (state) => {
      state.isCancelledPlacementLoading = true;
    },
    getCancelledPlacementDetailProcessed: (state, action) => {
      state.isCancelledPlacementLoading = false;
      const cancelledPlacement = action?.payload?.data?.documents;
      state.cancelledPlacement = cancelledPlacement?.length > 0 ? cancelledPlacement[0] : {};
    },
    getCancelledPlacementDetailError: (state) => {
      state.isCancelledPlacementLoading = false;
    },
    clearCancelledPlacementData: (state) => {
      state.cancelledPlacement = {};
    },
    updateCancelledPlacementV2: (state) => {
      state.isCancelledPlacementLoading = true;
    },
    updateCancelledPlacementProcessedV2: (state, action) => {
      state.isCancelledPlacementLoading = false;
      const cancelledPlacement = action?.payload?.data?.document;
      state.cancelledPlacement = cancelledPlacement || {};
    },
    updateCancelledPlacementErrorV2: (state) => {
      state.isCancelledPlacementLoading = false;
    },

    updateJobRosterEmployeeV2: (state) => {
      state.isRosterActionProcessing = true;
    },
    updateJobRosterEmployeeProcessedV2: (state) => {
      state.isRosterActionProcessing = false;
      state.isJobOrderDetailUpdated = true;
    },
    updateJobRosterEmployeeErrorV2: (state) => {
      state.isRosterActionProcessing = false;
    },

    revokeJobInvitationsV2: (state) => {
      state.isRosterActionProcessing = true;
    },
    revokeJobInvitationsProcessedV2: (state) => {
      state.isRosterActionProcessing = false;
      state.isJobOrderDetailUpdated = true;
    },
    revokeJobInvitationsErrorV2: (state) => {
      state.isRosterActionProcessing = false;
    },

    revokeJobOfferV2: (state) => {
      state.isRosterActionProcessing = true;
    },
    revokeJobOfferProcessedV2: (state) => {
      state.isRosterActionProcessing = false;
      state.isJobOrderDetailUpdated = true;
    },
    revokeJobOfferErrorV2: (state) => {
      state.isRosterActionProcessing = false;
    },

    approveOrRejectPlacementV2: (state) => {
      state.isRosterActionProcessing = true;
    },
    approveOrRejectPlacementProcessedV2: (state) => {
      state.isRosterActionProcessing = false;
      state.isJobOrderDetailUpdated = true;
    },
    approveOrRejectPlacementErrorV2: (state) => {
      state.isRosterActionProcessing = false;
    },

    approveOrRejectEgApplicationV2: (state) => {
      state.isRosterActionProcessing = true;
    },
    approveOrRejectEgApplicationProcessedV2: (state) => {
      state.isRosterActionProcessing = false;
      state.isJobOrderDetailUpdated = true;
    },
    approveOrRejectEgApplicationErrorV2: (state) => {
      state.isRosterActionProcessing = false;
    },

    inviteEmployeeV2: (state) => {
      state.isRosterActionProcessing = true;
    },
    inviteEmployeeProcessedV2: (state) => {
      state.isRosterActionProcessing = false;
      state.isJobOrderDetailUpdated = true;
    },
    inviteEmployeeErrorV2: (state) => {
      state.isRosterActionProcessing = false;
    },

    cancelPlacementV2: (state) => {
      state.isRosterActionProcessing = true;
    },
    cancelPlacementProcessedV2: (state) => {
      state.isRosterActionProcessing = false;
      state.isJobOrderDetailUpdated = true;
    },
    cancelPlacementErrorV2: (state) => {
      state.isRosterActionProcessing = false;
    },

    removeUserFromGroupV2: (state) => {
      state.isRosterActionProcessing = true;
    },
    removeUserFromGroupProcessedV2: (state) => {
      state.isRosterActionProcessing = false;
      state.isJobOrderDetailUpdated = true;
    },
    removeUserFromGroupErrorV2: (state) => {
      state.isRosterActionProcessing = false;
    },

    updateExtensionGroupV2: (state) => {
      state.isRosterActionProcessing = true;
    },
    updateExtensionGroupProcessedV2: (state) => {
      state.isRosterActionProcessing = false;
      state.isJobOrderDetailUpdated = true;
    },
    updateExtensionGroupErrorV2: (state) => {
      state.isRosterActionProcessing = false;
    },

    updateGroupOpeningsV2: (state) => {
      state.isRosterActionProcessing = true;
    },
    updateGroupOpeningsProcessedV2: (state) => {
      state.isRosterActionProcessing = false;
      state.isJobOrderDetailUpdated = true;
    },
    updateGroupOpeningsErrorV2: (state) => {
      state.isRosterActionProcessing = false;
    },

    updateShiftOpeningsV2: (state) => {
      state.isRosterActionProcessing = true;
    },
    updateShiftOpeningsProcessedV2: (state, action) => {
      state.isRosterActionProcessing = false;
      state.jobOrderDetail = {
        ...state.jobOrderDetail,
        numOpenings: action?.payload?.data?.document?.numOpenings,
        numOverstaff: action?.payload?.data?.document?.numOverstaff,
      };
      state.isJobOrderDetailUpdated = true;
    },
    updateShiftOpeningsErrorV2: (state) => {
      state.isRosterActionProcessing = false;
    },

    cancelSingleJobV2: (state) => {
      state.isCancelProcessing = true;
    },
    cancelSingleJobProcessedV2: (state) => {
      state.isCancelProcessing = false;
    },
    cancelSingleJobErrorV2: (state) => {
      state.isCancelProcessing = false;
    },
    cancelSeriesJobV2: (state) => {
      state.isCancelSeriesProcessing = true;
    },
    cancelSeriesJobProcessedV2: (state) => {
      state.isCancelSeriesProcessing = false;
    },
    cancelSeriesJobErrorV2: (state) => {
      state.isCancelSeriesProcessing = false;
    },

    updatePlacementDepartmentV2: (state) => {
      state.isRosterActionProcessing = true;
    },
    updatePlacementDepartmentProcessedV2: (state, action) => {
      state.isRosterActionProcessing = false;
      const updatedDocument = action?.payload?.data?.document;

      if (
        state.jobOrderDetail?.roster?.active &&
        updatedDocument?.id &&
        updatedDocument?.timecard?.departmentAllocation?.length > 0
      ) {
        const departmentAllocation = updatedDocument.timecard.departmentAllocation[0];
        state.jobOrderDetail.roster.active = state.jobOrderDetail.roster.active.map((placement) => {
          if (placement?.id === updatedDocument.id) {
            return {
              ...placement,
              department: {
                _id: departmentAllocation?.departmentId,
                name: departmentAllocation?.name,
              },
            };
          }
          return placement;
        });
      }
    },
    updatePlacementDepartmentErrorV2: (state) => {
      state.isRosterActionProcessing = false;
    },
  },
});

export const jobOrderDetailReducer = jobOrderDetailSlice.reducer;

export const {
  getJobOrderDetailV2,
  getJobOrderDetailProcessedV2,
  getJobOrderDetailErrorV2,
  setJobOrderDetailV2,
  getCancelledPlacementDetail,
  getCancelledPlacementDetailProcessed,
  getCancelledPlacementDetailError,
  clearCancelledPlacementData,
  updateCancelledPlacementV2,
  updateCancelledPlacementProcessedV2,
  updateCancelledPlacementErrorV2,
  updateJobRosterEmployeeV2,
  updateJobRosterEmployeeProcessedV2,
  updateJobRosterEmployeeErrorV2,
  revokeJobInvitationsV2,
  revokeJobInvitationsProcessedV2,
  revokeJobInvitationsErrorV2,
  revokeJobOfferV2,
  revokeJobOfferProcessedV2,
  revokeJobOfferErrorV2,
  approveOrRejectPlacementV2,
  approveOrRejectPlacementProcessedV2,
  approveOrRejectPlacementErrorV2,
  approveOrRejectEgApplicationV2,
  approveOrRejectEgApplicationProcessedV2,
  approveOrRejectEgApplicationErrorV2,
  inviteEmployeeV2,
  inviteEmployeeProcessedV2,
  inviteEmployeeErrorV2,
  cancelPlacementV2,
  cancelPlacementProcessedV2,
  cancelPlacementErrorV2,
  removeUserFromGroupV2,
  removeUserFromGroupProcessedV2,
  removeUserFromGroupErrorV2,
  updateExtensionGroupV2,
  updateExtensionGroupProcessedV2,
  updateExtensionGroupErrorV2,
  updateGroupOpeningsV2,
  updateGroupOpeningsProcessedV2,
  updateGroupOpeningsErrorV2,
  updateShiftOpeningsV2,
  updateShiftOpeningsProcessedV2,
  updateShiftOpeningsErrorV2,
  cancelSingleJobV2,
  cancelSingleJobProcessedV2,
  cancelSingleJobErrorV2,
  cancelSeriesJobV2,
  cancelSeriesJobProcessedV2,
  cancelSeriesJobErrorV2,
  updatePlacementDepartmentV2,
  updatePlacementDepartmentProcessedV2,
  updatePlacementDepartmentErrorV2,
} = jobOrderDetailSlice.actions;
